export const ACCOUNT_MENU_ITEM_ID = {
	PERSONAL_DETAILS: 'personal-details',
	PREFERENCES: 'preferences',
	PASSWORD_SECURITY: 'password-security',
	ATA_TRANSFERS: 'ata-transfers',
	STATEMENTS: 'statements',
	BETTING_HISTORY: 'betting-history',
	INBOX: 'inbox',
	ANNOUNCEMENTS: 'announcements',
	DEPOSIT: 'deposit',
	WITHDRAWAL: 'withdrawal',
	TRANSACTIONS: 'transactions-history',
	PAYMENT_ACCOUNTS: 'my-payment-accounts',
	SELF_EXCLUSION_LIMIT: 'self-exclusion-limit',
	MY_BONUS: 'my-bonus',
}
export const RIGHT_SIDE_ACCOUNT_COMPONENTS = [
	ACCOUNT_MENU_ITEM_ID.ANNOUNCEMENTS
]
export const NGC_TAB = {
	DEPOSIT: 'deposit',
	WITHDRAWAL: 'withdrawal',
	TRANSACTIONS: 'transactions',
	PAYMENT_ACCOUNTS: 'payment-accounts',
}
export const CUSTOM_INPUT = {
	RADIO: 'RADIO',
	RADIO_INLINE: 'RADIO_INLINE',
	CHECKBOX: 'CHECKBOX',
	SELECT: 'SELECT',
	INPUT_DROPDOWN: 'INPUT_DROPDOWN',
	TOOLTIP: 'TOOLTIP'
}

export const STATUS_WAGGER = Object.freeze({
	CANCELLED: 'CANCELLED',
});


export const PERIOD_OPTIONS = [
	{
		text: '6 months',
		value: 30*6
	},
	{
		text: '1 year',
		value: 365
	},
	{
		text: '3 years',
		value: 365*3
	},
	{
		text: '5 years',
		value: 365*5
	},
	{
		text: 'Permanent',
		value: 365*9999
	},
]

export const DEFAULT_MARKET_MOBILE_STANDARD = [
	{
		label: 'Default',
		value: 'default'
	},
	{
		label: 'Money Line/1X2',
		value: 'moneyline'
	},
	{
		label: 'Handicap',
		value: 'spread'
	},
	{
		label: 'Total',
		value: 'total'
	}
]

export const DEACTIVATE_TEMPORARILY_ACTION_ID = 3;

export const DATA_DATE_TYPE = {
	TIME: 'Time',
	DATE: 'Date'
}

export const PASSWORD_TYPE  = {
	OLD_PASS: 'oldPassword',
	NEW_PASS: 'newPassword',
	CONFIRM_PASS: 'confirmPassword'
};

export const MFA_CONSTANTS = {
	SET_MFA_METHOD_TYPE_SUCCESS: 'SET_MFA_METHOD_TYPE_SUCCESS',
	SAVE_QR_OTP_SUCCESS:'QR_OTP_SAVE_SUCCESS',
	SAVE_QR_OTP_ERROR: 'SAVE_QR_OTP_ERROR',
	EMAIL_OTP_EXPIRED: 'EMAIL_OTP_EXPIRED',
	QR_OTP_SAVE_FAILED: 'QR_OTP_SAVE_FAILED',
	EMAIL_AUTH: 'EMAIL1',
	APP_AUTH: 'TOTP_APP',
	DATA_PREFIX_IMG: 'data:image/png;base64,'
};



// WEBPACK FOOTER //
// ./src/app/components/AccountComponent/Constants.js